import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';

import { FacetComponent } from './facet.component';
import { KeyboardFocusModule, IconModule } from '@spartacus/storefront';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    CommonModule,
    KeyboardFocusModule,
    IconModule
  ],
  declarations: [FacetComponent],
  exports: [FacetComponent],
})
export class FacetModule {}
